import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString3dhdjl9yf50de as toString,
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  copyOf3rutauicler23 as copyOf,
  copyOf2ng0t8oizk6it as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { toByte4i43936u611k as toByte } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { JsonScope_instance2v4oowlow0hci as JsonScope_instance } from './internal/JsonScope.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { IOException3fje1ukjwthwb as IOException } from '../../../../../../okio-parent-okio/okio/NonJvmPlatform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function hexString($this, _this__u8e3s4) {
  var value = _this__u8e3s4;
  return toString(charCodeAt('0123456789abcdef', value >>> 4 | 0)) + toString(charCodeAt('0123456789abcdef', value & 15));
}
function _get_separator__ee6j2k($this) {
  var tmp;
  // Inline function 'kotlin.text.isNullOrEmpty' call
  var this_0 = $this.a4a_1;
  if (this_0 == null || charSequenceLength(this_0) === 0) {
    tmp = ':';
  } else {
    tmp = ': ';
  }
  return tmp;
}
function open($this, empty, openBracket) {
  beforeValue($this);
  pushScope($this, empty);
  $this.e4a_1[$this.b4a_1 - 1 | 0] = 0;
  $this.z49_1.a3z(openBracket);
  return $this;
}
function close($this, empty, nonempty, closeBracket) {
  var context = peekScope($this);
  // Inline function 'kotlin.check' call
  if (!!(!(context === nonempty) && !(context === empty))) {
    var message = 'Nesting problem.';
    throw IllegalStateException().o(toString_0(message));
  }
  // Inline function 'kotlin.check' call
  if (!($this.f4a_1 == null)) {
    var message_0 = 'Dangling name: ' + $this.f4a_1;
    throw IllegalStateException().o(toString_0(message_0));
  }
  $this.b4a_1 = $this.b4a_1 - 1 | 0;
  $this.d4a_1[$this.b4a_1] = null;
  var _array__4zh2yp = $this.e4a_1;
  var _index_0__fvwizt = $this.b4a_1 - 1 | 0;
  _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
  if (context === nonempty) {
    newline($this);
  }
  $this.z49_1.a3z(closeBracket);
  return $this;
}
function writeDeferredName($this) {
  if (!($this.f4a_1 == null)) {
    beforeName($this);
    Companion_getInstance().i4a($this.z49_1, ensureNotNull($this.f4a_1));
    $this.f4a_1 = null;
  }
}
function newline($this) {
  if ($this.a4a_1 == null) {
    return Unit_instance;
  }
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(10);
  var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
  $this.z49_1.c3z(tmp$ret$0);
  var i = 1;
  var size = $this.b4a_1;
  while (i < size) {
    $this.z49_1.a3z($this.a4a_1);
    i = i + 1 | 0;
  }
}
function beforeName($this) {
  var context = peekScope($this);
  if (context === 5) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(44);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    $this.z49_1.c3z(tmp$ret$0);
  } else {
    // Inline function 'kotlin.check' call
    if (!(context === 3)) {
      var message = 'Nesting problem.';
      throw IllegalStateException().o(toString_0(message));
    }
  }
  newline($this);
  replaceTop($this, 4);
}
function beforeValue($this) {
  switch (peekScope($this)) {
    case 7:
      throw IllegalStateException().o('JSON must have only one top-level value.');
    case 6:
      replaceTop($this, 7);
      break;
    case 1:
      replaceTop($this, 2);
      newline($this);
      break;
    case 2:
      // Inline function 'kotlin.code' call

      var this_0 = _Char___init__impl__6a9atx(44);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      $this.z49_1.c3z(tmp$ret$0);
      newline($this);
      break;
    case 4:
      $this.z49_1.a3z(_get_separator__ee6j2k($this));
      replaceTop($this, 5);
      break;
    default:
      throw IllegalStateException().o('Nesting problem.');
  }
}
function peekScope($this) {
  // Inline function 'kotlin.check' call
  if (!!($this.b4a_1 === 0)) {
    var message = 'JsonWriter is closed.';
    throw IllegalStateException().o(toString_0(message));
  }
  return $this.c4a_1[$this.b4a_1 - 1 | 0];
}
function pushScope($this, newTop) {
  if ($this.b4a_1 === $this.c4a_1.length) {
    $this.c4a_1 = copyOf($this.c4a_1, imul($this.c4a_1.length, 2));
    $this.d4a_1 = copyOf_0($this.d4a_1, imul($this.d4a_1.length, 2));
    $this.e4a_1 = copyOf($this.e4a_1, imul($this.e4a_1.length, 2));
  }
  var tmp = $this.c4a_1;
  var _unary__edvuaz = $this.b4a_1;
  $this.b4a_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = newTop;
}
function replaceTop($this, topOfStack) {
  $this.c4a_1[$this.b4a_1 - 1 | 0] = topOfStack;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.g4a_1 = '0123456789abcdef';
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        // Inline function 'kotlin.apply' call
        var this_0 = Array(128);
        var inductionVariable = 0;
        if (inductionVariable <= 31)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this_0[i] = '\\u00' + hexString(Companion_getInstance(), toByte(i));
          }
           while (inductionVariable <= 31);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(34);
        this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(92);
        this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(9);
        this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(8);
        this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
        // Inline function 'kotlin.code' call
        var this_5 = _Char___init__impl__6a9atx(10);
        this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
        // Inline function 'kotlin.code' call
        var this_6 = _Char___init__impl__6a9atx(13);
        this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
        tmp.h4a_1 = this_0;
      }
      i4a(sink, value) {
        var replacements = this.h4a_1;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(34);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        sink.c3z(tmp$ret$0);
        var last = 0;
        var length = value.length;
        var inductionVariable = 0;
        if (inductionVariable < length)
          $l$loop_0: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var c = charCodeAt(value, i);
            var replacement;
            // Inline function 'kotlin.code' call
            if (Char__toInt_impl_vasixd(c) < 128) {
              // Inline function 'kotlin.code' call
              replacement = replacements[Char__toInt_impl_vasixd(c)];
              if (replacement == null) {
                continue $l$loop_0;
              }
            } else {
              if (c === _Char___init__impl__6a9atx(8232)) {
                replacement = '\\u2028';
              } else {
                if (c === _Char___init__impl__6a9atx(8233)) {
                  replacement = '\\u2029';
                } else {
                  continue $l$loop_0;
                }
              }
            }
            if (last < i) {
              sink.b3z(value, last, i);
            }
            sink.a3z(replacement);
            last = i + 1 | 0;
          }
           while (inductionVariable < length);
        if (last < length) {
          sink.b3z(value, last, length);
        }
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(34);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_1);
        sink.c3z(tmp$ret$3);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var BufferedSinkJsonWriterClass;
function BufferedSinkJsonWriter() {
  if (BufferedSinkJsonWriterClass === VOID) {
    class $ {
      constructor(sink, indent) {
        Companion_getInstance();
        indent = indent === VOID ? null : indent;
        this.z49_1 = sink;
        this.a4a_1 = indent;
        this.b4a_1 = 0;
        this.c4a_1 = new Int32Array(64);
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.d4a_1 = Array(64);
        this.e4a_1 = new Int32Array(64);
        this.f4a_1 = null;
        pushScope(this, 6);
      }
      j4a() {
        return joinToString(JsonScope_instance.s4a(this.b4a_1, this.c4a_1, this.d4a_1, this.e4a_1), '.');
      }
      h41() {
        writeDeferredName(this);
        return open(this, 1, '[');
      }
      i41() {
        return close(this, 1, 2, ']');
      }
      c41() {
        writeDeferredName(this);
        return open(this, 3, '{');
      }
      d41() {
        return close(this, 3, 5, '}');
      }
      e48(name) {
        // Inline function 'kotlin.check' call
        if (!!(this.b4a_1 === 0)) {
          var message = 'JsonWriter is closed.';
          throw IllegalStateException().o(toString_0(message));
        }
        // Inline function 'kotlin.check' call
        if (!(this.f4a_1 == null)) {
          var message_0 = 'Nesting problem.';
          throw IllegalStateException().o(toString_0(message_0));
        }
        this.f4a_1 = name;
        this.d4a_1[this.b4a_1 - 1 | 0] = name;
        return this;
      }
      o41(value) {
        writeDeferredName(this);
        beforeValue(this);
        Companion_getInstance().i4a(this.z49_1, value);
        var _array__4zh2yp = this.e4a_1;
        var _index_0__fvwizt = this.b4a_1 - 1 | 0;
        _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
        return this;
      }
      h40() {
        return this.t4a('null');
      }
      y41(value) {
        return this.t4a(value ? 'true' : 'false');
      }
      t41(value) {
        // Inline function 'kotlin.require' call
        if (!(!isNaN_0(value) && !isInfinite(value))) {
          var message = 'Numeric values must be finite, but was ' + value;
          throw IllegalArgumentException().s2(toString_0(message));
        }
        return this.t4a(value.toString());
      }
      q41(value) {
        return this.t4a(value.toString());
      }
      w41(value) {
        return this.t4a(value.toString());
      }
      u4a(value) {
        return this.t4a(value.v4a_1);
      }
      d42(value) {
        // Inline function 'kotlin.apply' call
        this.h40();
        return this;
      }
      t4a(value) {
        writeDeferredName(this);
        beforeValue(this);
        this.z49_1.a3z(value);
        var _array__4zh2yp = this.e4a_1;
        var _index_0__fvwizt = this.b4a_1 - 1 | 0;
        _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
        return this;
      }
      q6() {
        this.z49_1.q6();
        var size = this.b4a_1;
        if (size > 1 || (size === 1 && !(this.c4a_1[size - 1 | 0] === 7))) {
          throw IOException().p3z('Incomplete document');
        }
        this.b4a_1 = 0;
      }
    }
    initMetadataForClass($, 'BufferedSinkJsonWriter');
    BufferedSinkJsonWriterClass = $;
  }
  return BufferedSinkJsonWriterClass;
}
//region block: exports
export {
  BufferedSinkJsonWriter as BufferedSinkJsonWriter1xl4ankftitqq,
};
//endregion

//# sourceMappingURL=BufferedSinkJsonWriter.mjs.map
